import { render, staticRenderFns } from "./FleetColor.vue?vue&type=template&id=50ef1c98"
import script from "./FleetColor.vue?vue&type=script&setup=true&lang=ts"
export * from "./FleetColor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FleetColor.vue?vue&type=style&index=0&id=50ef1c98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports